import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const QrCodeGeneratorAndroid: React.FC = () => (
  <SEOLandingPage
    title="QR Code Generator for Android — Free QR Code Maker | Cosmovex"
    metaDescription="Free QR code generator and maker for Android. Create QR codes for links, Wi-Fi, contacts, text, email, phone and more — preview live, save or share, and keep every code in your history. No account needed."
    ogTitle="QR Code Generator for Android — Make QR Codes Free"
    h1="QR Code Generator for Android"
    intro="Make a QR code for anything in seconds. Type a link, Wi-Fi network, contact, or message and QR Scanner & Generator turns it into a clean, high-resolution QR code you can save or share — free, offline, no account."
    paragraphs={[
      "A good QR code maker should get out of the way. Pick what you want to share — a website link, your guest Wi-Fi, a contact card, plain text, an email, a phone number, an SMS, a map location, or a calendar event — fill in the details, and watch a live preview update as you type. When it looks right, save it to your gallery or share it straight to any app.",
      "Wi-Fi codes are the crowd favorite: let visitors join your network by pointing their camera at a code on the fridge instead of spelling out a password. Contact (vCard) codes hand over your details in one scan. Link codes move a long URL from your screen to someone else's phone without a single keystroke.",
      "Every code you generate is saved automatically, so the menu link or event QR you made last week is one tap away. Group codes into collections, pin the ones you reach for most, and re-open, copy or share any of them in seconds — no re-typing, no screenshots to hunt for.",
      "It also scans. The same app reads QR codes and barcodes with your camera or from a saved photo, with smart one-tap actions on every result. Generating and scanning both work offline, in a clean dark interface, with no sign-up ever required.",
    ]}
    features={[
      "Generate QR codes for links, Wi-Fi, contacts, text, email, SMS & phone",
      "Live preview updates as you type",
      "Save codes to your gallery or share them anywhere",
      "Wi-Fi QR codes — guests join without typing a password",
      "Contact (vCard) QR codes share your details in one scan",
      "Automatic history plus collections to stay organized",
      "Also scans QR codes and barcodes — camera or gallery photo",
      "Works offline · no account · free to download",
    ]}
    howToSteps={[
      { name: "Pick a type", text: "Choose what to encode — link, Wi-Fi, contact, text, email, phone and more." },
      { name: "Enter details", text: "Fill in the fields and watch the QR code preview update live." },
      { name: "Save or share", text: "Save the code to your gallery or share it to any app." },
      { name: "Find it later", text: "Every code is saved to history and collections for one-tap reuse." },
    ]}
    faqs={[
      { q: "Is the QR code generator free?", a: "Yes — it's free to download and create QR codes, supported by ads. A one-time Pro upgrade removes ads and unlocks custom colors and shapes." },
      { q: "What kinds of QR codes can I make?", a: "Links, Wi-Fi networks, contact cards, plain text, email, SMS, phone numbers, map locations, calendar events and social profiles." },
      { q: "Do the QR codes expire?", a: "No. They're static codes that encode your data directly, so they keep working forever." },
      { q: "Does it work offline?", a: "Yes — generating and scanning both work without an internet connection, and no account is required." },
    ]}
    related={[
      { label: "QR Scanner & Generator for Android", path: "/qr-scanner-android", tagline: "Scan and create QR codes" },
      { label: "Barcode Scanner for Android", path: "/barcode-scanner-android", tagline: "Read product barcodes" },
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.qrpilot"
    icon="/images/play/qrpilot.png"
    appName="QR Scanner & Generator"
    accentColor="#A8720E"
    canonicalPath="/qr-code-generator-android"
  />
);

export default QrCodeGeneratorAndroid;
